import firebase from 'firebase';

import configs from '../../configs';
import axios from '../util/axios';

export const FREUD_BASE_URL = configs.freud.BASE_URL;

export type ResourceData = {
    id: string;

    tag?: string;
    shortDescription?: string;
    sectionId?: string;
    description?: string;
    /**
     * ISO 8601 string
     */
    publishedAt?: string;

    archivedAt?: boolean;
    /**
     * ISO 8601 string
     */
    createdAt: string;
    /**
     * ISO 8601 string
     */
    updatedAt: string;
};

export type ResourceUpsertData = Pick<
    ResourceData,
    'tag' | 'shortDescription' | 'description' | 'publishedAt' | 'sectionId'
>;

export type ResourcesGetListQuery = {
    includeArchived?: boolean;
};

export const getResources = async (fbUser: firebase.User, query?: ResourcesGetListQuery): Promise<ResourceData[]> => {
    let url = FREUD_BASE_URL + `/resources`;
    if (query?.includeArchived) {
        url += '?includeArchived=true';
    }
    try {
        const response = await axios(url, {
            method: 'GET',
            headers: { Authorization: `idToken ${await fbUser.getIdToken()}` },
        });
        if (response.status != 200) {
            console.debug(response);
            throw new Error('Error fetching');
        }

        return response.data;
    } catch (e) {
        console.debug('Error', e);
        throw e;
    }
};

export const createResource = async (fbUser: firebase.User, article: ResourceUpsertData): Promise<void> => {
    const url = FREUD_BASE_URL + `/resources`;
    try {
        const response = await axios(url, {
            method: 'POST',
            headers: { Authorization: `idToken ${await fbUser.getIdToken()}` },
            data: article,
        });
        if (response.status != 200) {
            console.debug(response);
            throw new Error('Error fetching');
        }

        return response.data;
    } catch (e) {
        console.debug('Error', e);
        throw e;
    }
};

export const updateResource = async (
    fbUser: firebase.User,
    id: string,
    resource: ResourceUpsertData,
): Promise<void> => {
    const url = FREUD_BASE_URL + `/resources/${id}`;
    try {
        const response = await axios(url, {
            method: 'PATCH',
            headers: { Authorization: `idToken ${await fbUser.getIdToken()}` },
            data: resource,
        });
        if (response.status != 200) {
            console.debug(response);
            throw new Error('Error fetching');
        }

        return response.data;
    } catch (e) {
        console.debug('Error', e);
        throw e;
    }
};

export const archiveResource = async (fbUser: firebase.User, id: string): Promise<void> => {
    const url = FREUD_BASE_URL + `/resources/${id}/archive`;
    try {
        const response = await axios(url, {
            method: 'POST',
            headers: { Authorization: `idToken ${await fbUser.getIdToken()}` },
        });
        if (response.status != 200) {
            console.debug(response);
            throw new Error('Error fetching');
        }

        return response.data;
    } catch (e) {
        console.debug('Error', e);
        throw e;
    }
};

export const unarchiveResource = async (fbUser: firebase.User, id: string): Promise<void> => {
    const url = FREUD_BASE_URL + `/resources/${id}/unarchive`;
    try {
        const response = await axios(url, {
            method: 'POST',
            headers: { Authorization: `idToken ${await fbUser.getIdToken()}` },
        });
        if (response.status != 200) {
            console.debug(response);
            throw new Error('Error fetching');
        }

        return response.data;
    } catch (e) {
        console.debug('Error', e);
        throw e;
    }
};
